import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BookingContainer } from '../booking.container';
// import html2canvas from 'html2canvas';
import * as jsPDF from 'jspdf';
@Component({
    selector: 'app-booking-confirmation',
    templateUrl: 'booking-confirmation.component.html',
    styleUrls: ['booking-confirmation.component.css', 'booking-confirmation.component.scss']
})

export class BookingConfirmationComponent implements OnInit {

    offerId;
    printableVoucherEnabled = false;
    guestDetails = new Array();
    messageText = '';
    guestEmail: String;

    isSuccessOpen: Boolean = true;

    constructor(private route:  ActivatedRoute, public bookingContainer: BookingContainer) {
      this.route.params.subscribe(params => {
        if (params['id']) {
          this.offerId = params['id'];
        }
      });
      this.guestEmail = bookingContainer.guestEmail;
    }

    ngOnInit() {
        this.bookingContainer.changeHeaderType('voucher');
        // this.offerId = this.route.snapshot.paramMap.get('id');
        this.bookingContainer.populateWithData(this.offerId);
        // this.bookingContainer.changeHeaderType();
    }

    getFacilitiesTab = () => this.bookingContainer.facilitiesTab;
    getOfferInfo = () => this.bookingContainer.offerInfo;
    getLanguages = () => this.bookingContainer.languages;
    getCheckin = () => this.bookingContainer.checkinout;
    getPricingPolicy = () => this.bookingContainer.pricingPolicy;
    getUser = () => this.bookingContainer.user;
    getBookingRequest = () => this.bookingContainer.bookingRequest;
    getHotelInfo = () => this.bookingContainer.hotelInfo;
    getSelectedRooms = () => this.bookingContainer.selectedRooms;
    getOfferId = () => this.bookingContainer.offerId;
    getMapInfo = () => this.bookingContainer.getMapInfo();

    getGuestDetails() {
        if (this.guestDetails.length > 0 && this.guestDetails.length === this.bookingContainer.selectedRooms.length ) {
            return this.guestDetails;
        }
        // if (this.bookingContainer.bookingRequest === null || this.bookingContainer.bookingRequest === undefined) { return; }
        this.guestDetails = new Array();
        // if (this.bookingContainer.bookingRequest.user === null) {
            this.bookingContainer.selectedRooms.forEach(room => {
                const user = this.bookingContainer.getUserInfo();
                const details = {
                    firstName: user.name, lastName: user.surname,
                    email: user.email, phone: '', country: '',
                    arrivalTime: '', roomId: room.room.id
                };
                this.guestDetails.push(details);
            });
        // } else {
            /*this.bookingContainer.selectedRooms.forEach(room => {
                const details = {
                    firstName: this.bookingContainer.bookingRequest.user.name,
                    lastName: this.bookingContainer.bookingRequest.user.surname,
                    email: this.bookingContainer.bookingRequest.user.email,
                    phone: this.bookingContainer.bookingRequest.user.phone,
                    country: this.bookingContainer.bookingRequest.user.country,
                    arrivalTime: '',
                    roomId: room.room.id
                };
                this.guestDetails.push(details);
            });*/
        // }
        return this.guestDetails;
    }

    getUserName() {
        // if (this.bookingContainer.bookingRequest === null || this.bookingContainer.bookingRequest === undefined) { return ''; }
        // if (this.bookingContainer.bookingRequest.user === null) {
            return this.bookingContainer.getUserInfo().name;
        /*} else {
            return this.bookingContainer.bookingRequest.user.name;
        }*/
    }


    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      }

    async saveToPDF() {
        /*this.printableVoucherEnabled = true;
        this.bookingContainer.enableSpinner(true);
        // doc.text(50, 90, this.problems.length.toString());
        // doc.text(50,100,'page 1')
        await this.sleep(1000);
        const voucherHeight = document.getElementById('voucher').clientHeight;
        const voucherWidth = document.getElementById('voucher').clientWidth;
        const ratio = voucherHeight / voucherWidth;
        // pdf.addPage();
        // doc.text(50, 100, 'page 2')
        const pdf = new jsPDF({orientation: 'p', unit: 'cm', format: [voucherWidth * 0.164583333, voucherHeight * 0.164583333]});
        pdf.text(35, 25, 'Paranyan loves jsPDF');
        html2canvas(document.getElementById('voucher')).then(canvas => {
            const width = pdf.internal.pageSize.width;
            let height = pdf.internal.pageSize.height;
            height = ratio * voucherWidth * 0.00264583333;
            const img = canvas.toDataURL('image/png');
            pdf.addImage(img, 'JPEG', 0.5, 1, voucherWidth * 0.00464583333  , height + 4 );
            // pdf.addImage(img, 'JPEG', 100, 100);
            pdf.save('MyBooking.pdf');
            this.printableVoucherEnabled = false;
            this.bookingContainer.enableSpinner(false);
        });*/
        console.log('save pdf clicked');

    }

    sendMessage(message) {
        this.bookingContainer.sendMessage(message);
    }
}
